import { useEffect, useState } from 'react';

/**
 * Hook to detect if the device supports hover (like desktop with mouse)
 * vs touch devices (mobile, tablets) that don't support hover naturally
 *
 * @returns true if device supports hover, false if it's a touch device
 */
export const useHoverSupport = () => {
  const [supportsHover, setSupportsHover] = useState(true);

  useEffect(() => {
    // Check if device supports hover using media query
    // This is the most reliable way to detect touch devices
    const mediaQuery = window.matchMedia('(hover: hover)');

    const updateHoverSupport = () => {
      setSupportsHover(mediaQuery.matches);
    };

    // Set initial value
    updateHoverSupport();

    // Listen for changes (e.g., when device orientation changes)
    mediaQuery.addEventListener('change', updateHoverSupport);
    return () => {
      mediaQuery.removeEventListener('change', updateHoverSupport);
    };
  }, []);

  return supportsHover;
};
